import * as T from 'prop-types';
import styled from 'styled-components/macro';

import { Alert, Box, Flex, Icon, Text } from '@olist/united';

import { ALERT_VARIATION } from '../../pages/onboarding/constants';

const AlertInformation = ({ text, title }) => (
  <Flex flexDirection="column" width={[1]} ml="3%" mr="3%">
    {title && <Text>{title}</Text>}
    <Text>{text}</Text>
  </Flex>
);
const AlertIcon = ({ iconName }) => (
  <Box>
    <Icon titleAccess={iconName} size="20px" name={iconName} color="foundation.errorDark" />
  </Box>
);

const ContainerWrapper = styled(Flex)`
  align-items: center;
  bottom: 5%;
  justify-content: center;
  left: 0;
  position: absolute;
  width: 100%;
`;

const AlertNotification = ({ children, variation }) => {
  return (
    <ContainerWrapper>
      <Flex width={[1, '75%']} maxWidth="370px">
        <Alert variation={variation}>
          <Flex flexDirection="row" justifyContent="space-between">
            {children}
          </Flex>
        </Alert>
      </Flex>
    </ContainerWrapper>
  );
};

AlertNotification.propTypes = {
  children: T.node.isRequired,
  variation: T.oneOf([
    ALERT_VARIATION.alternate,
    ALERT_VARIATION.danger,
    ALERT_VARIATION.shadow,
    ALERT_VARIATION.warning,
  ]).isRequired,
};

AlertIcon.propTypes = {
  iconName: T.string.isRequired,
};

AlertInformation.propTypes = {
  title: T.string,
  text: T.string.isRequired,
};

AlertInformation.defaultProps = {
  title: '',
};

AlertNotification.Information = AlertInformation;
AlertNotification.Icon = AlertIcon;

export default AlertNotification;
